/** Accept only same-origin relative paths (no protocol-relative `//`). */
export function safeRedirectPath(raw: unknown): string | null {
  const path = String(raw ?? '').trim()
  if (!path.startsWith('/') || path.startsWith('//')) {
    return null
  }

  return path
}
